import { HttpInterceptorFn, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const crcViewScopeInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.method !== 'GET' || !request.url.startsWith(environment.baseUrl) || request.url.includes('/operating-scope')) {
    return next(request);
  }

  let user: any = null;
  let active: any = null;
  try {
    user = JSON.parse(localStorage.getItem('user') ?? 'null');
    active = JSON.parse(localStorage.getItem('active-crc-view-scope') ?? 'null');
  } catch {
    return next(request);
  }

  if (user?.accountType !== 'crc' || !active?.crcId || request.params.has('division_ids[]')) {
    return next(request);
  }

  let params: HttpParams = request.params.set('view', active.view === 'originated' ? 'originated' : 'operated');
  for (const divisionId of active.divisionIds ?? []) {
    params = params.append('division_ids[]', Number(divisionId));
  }

  return next(request.clone({ params }));
};
